import React from 'react';

const lazyRetry = function (componentImport, name = 'router') {
  return new Promise((resolve, reject) => {
    // 检查是否已经刷新过了
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem(`${name}-retry-lazy-refreshed`) || 'false',
    );
    // 动态导入组件
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem(`${name}-retry-lazy-refreshed`, 'false');
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // 没有刷新过，需要刷新页面刷新
          window.sessionStorage.setItem(`${name}-retry-lazy-refreshed`, 'true');
          // return window.location.reload(); //
        }
        reject(error);
      });
  });
};

export const lazy = (componentImport) => React.lazy(() => lazyRetry(componentImport));
